import React from 'react';
import { useNavigate } from 'react-router-dom';

const PaymentFailed = () => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 text-center">
            <div className="bg-red-100 p-6 rounded-full mb-6">
                <svg className="w-16 h-16 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
            </div>
            <h1 className="text-3xl font-bold text-gray-900 mb-4">Payment Failed</h1>
            <p className="text-lg text-gray-600 mb-8 max-w-md">
                We're sorry, but your transaction could not be processed. This might be due to insufficient funds, an expired card, or a temporary issue with the payment provider.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
                <button
                    onClick={() => navigate('/pricing')}
                    className="px-8 py-3 bg-primary text-white rounded-md font-medium hover:bg-primary-dark transition-colors"
                >
                    Try Again
                </button>
                <button
                    onClick={() => navigate('/contact-us')}
                    className="px-8 py-3 bg-gray-200 text-gray-800 rounded-md font-medium hover:bg-gray-300 transition-colors"
                >
                    Contact Support
                </button>
            </div>
        </div>
    );
};

export default PaymentFailed;
